// extracted by mini-css-extract-plugin
module.exports = {"question-modal":"QuestionModal_question-modal__4EMz8"};